import { render, staticRenderFns } from "./OrcamentoTabelaDash.vue?vue&type=template&id=4f70164d&lang=html&"
import script from "./OrcamentoTabelaDash.vue?vue&type=script&lang=js&"
export * from "./OrcamentoTabelaDash.vue?vue&type=script&lang=js&"
import style0 from "../../../../../../shared-components/generico/Pagination.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/dashboard/cadeia/orcamento/OrcamentoTabelaDash.vue
// module id = 1183
// module chunks = 28